export default "__VITE_ASSET__KI$LNEIw__"